<input #input [style.text-align]="align" [type]="!readonly ? 'text' :'hidden'" [placeholder]="placeholder || ''" [title]="title || ''" [required]="required" [attr.disabled]="disabled" [disabled]="disabled"/>
<ng-container *ngIf="disabled || readonly">
  
</ng-container>